<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		:columns="columns"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		@changedPage="changedPage"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'pmcNo'">
				<span class="highlighted" @click="() => openPopup(slotProps.row)">{{ slotProps.row.pmcNo }}</span>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: { scrId: { type: String, default: '' } },
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.mainResultList;
		},
		columns() {
			return this.getColumns_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		openPopup(row) {
			this.$emit('openPopup', row);
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	}
};
</script>

<style></style>
